import { getBudgetFriendlyETFs } from "../../services/TradingMallService";
import { textEllipsis, TITLE_CHAR_LIMIT } from "../ClpStockCards/clpCardConstant";
import BudgetETFsClient from "./BudgetETFsClinet";
import { mapResponseToStocks } from "./budgetEtfUtils";
import {
  BUDGET_ETF_FALLBACK_STOCK_NOT_FOUND_IMG_URL,
  BUDGET_ETF_DEFAULT_LOGGED_IN_REDIRECTION_URL,
  BUDGET_ETF_DEFAULT_SCREEN,
  BUDGET_ETF_FILTERS,
  BudgetETFsProps,
  BudgetETFStocksByFilter,
  IBudgetFriendlyETFsResponse,
} from "./BudgetETFTypes";

const DEFAULT_TITLE = "Budget-friendly ETFs";

export const BudgetETFs = async ({ content }: BudgetETFsProps) => {
  let responses: Array<IBudgetFriendlyETFsResponse | null> = [];

  try {
    const results = await Promise.allSettled(
      BUDGET_ETF_FILTERS.map((filter) => {
        if (!filter?.value) {
          return Promise.resolve(null);
        }

        return getBudgetFriendlyETFs({
          page: 1,
          limit: 10,
          sort: "amount_high_to_low",
          ltpFilter: filter.value,
        });
      }),
    );

    responses = results.map((result) =>
      result.status === "fulfilled" ? (result.value ?? null) : null,
    );
  } catch {
    return null;
  }

  const stocksByFilter = BUDGET_ETF_FILTERS.reduce<BudgetETFStocksByFilter>(
    (acc, filter, index) => {
      if (!filter?.value) return acc;

      acc[filter.value] = mapResponseToStocks(responses[index] ?? null);
      return acc;
    },
    {},
  );

  const hasAnyStocks = Object.values(stocksByFilter).some(
    (stocks) => (stocks?.length ?? 0) > 0,
  );

  if (!hasAnyStocks) {
    return null;
  }

  return (
    <section>
      <BudgetETFsClient
        stocksByFilter={stocksByFilter}
        title={textEllipsis(
          content?.componentTitle?.trim() ?? DEFAULT_TITLE,
          TITLE_CHAR_LIMIT,
        )}
        viewAllLabel={content?.label ?? "View all"}
        viewAllHref={content?.redirectLink}
        componentPosition={content?.componentPosition}
        openInNewTab={content?.ctaInNewTab}
        defaultImage={content?.defaultImageLink}
        stockNotFoundText={content?.stockNotFoundText ?? "No ETFs found."}
        stockNotFoundImgUrl={
          content?.stockNotFoundImgUrl ?? BUDGET_ETF_FALLBACK_STOCK_NOT_FOUND_IMG_URL
        }
        modalTitle={content?.modalTitle}
        modalBtnCta={content?.modalBtnCta}
        successMsg={content?.successMsg}
        errorMsg={content?.errorMsg}
        loggedInRedirectionUrl={
          content?.loggedInRedirectionUrl ?? BUDGET_ETF_DEFAULT_LOGGED_IN_REDIRECTION_URL
        }
        screen={content?.screen ?? BUDGET_ETF_DEFAULT_SCREEN}
        webViewTitle={content?.webViewTitle}
      />
    </section>
  );
};

export default BudgetETFs;
